/** 轉倉明細「庫編設定」說明（部分轉時）。 */
export const STOCK_NO_POLICY_TIP =
  '只有轉出一部分時，要選舊庫存編號留在剩下的還是轉出去的那邊';
